import { createContext, useContext } from 'react';

/**
 * Surfaces the producing drafter node's id (plus the surrounding
 * thread id, since `ChatAssistantMessage` itself doesn't carry one) to
 * inline markdown elements like `CodeDraftElement`, so they can wire
 * up node-scoped flows like Recreate. Provided only when a drafter's
 * body is rendering; `useDrafterNode()` returns null elsewhere.
 */
const DrafterNodeContext = createContext<{ nodeId: number; threadId: string } | null>(null);

export const DrafterNodeProvider = DrafterNodeContext.Provider;

export function useDrafterNode(): { nodeId: number; threadId: string } | null {
  return useContext(DrafterNodeContext);
}
